/**
 * @description Hotfix for correcting previously saved dates when an entity is updated.
 * also used to format dates that users provide manually (not using the datepicker) 
 * @author Per-Anders Karlsson
 */

export class DateUpdateFix {

    /**
     * Adds a timestamp of 12:00:00 to a date.
     * @param dateToFix date without timestamp
     * @returns date with timestamp
     */
    fixDateOnUpdate(dateToFix){
        if (dateToFix != null && dateToFix != '') {
            let fixedDate = new Date(dateToFix);
            fixedDate.setHours(14);
            return fixedDate
        } else {
            return null
        }
    }
}